import React from "react";
import logo from "../../assets/site_logo.png";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../provider/AuthProvider";
import Swal from "sweetalert2";
import { handleSessionExpiry } from "../../Services/session";
import axios from "axios";
import { API_URL } from "../../Services/UserServices";
import { useState, useEffect } from "react";
import { NONE, ACTIVE } from "../../Services/subscription";
import { useSubscription } from "../../provider/SubscriptionProvider";
const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  let routes = [
    {
      id: 1,
      name: "Home",
      path: "/",
      Active: pathname === "/" ? "active" : "",
    },
    {
      id: 2,
      name: "Free Calculator",
      path: "/FreeCalculator",
      Active: pathname === "/FreeCalculator" ? "active" : "",
    },
    {
      id: 3,
      name: "About Us",
      path: "/About",
      Active: pathname === "/About" ? "active" : "",
    },
    {
      id: 4,
      name: "Pricing",
      path: "/Pricing",
      Active: pathname === "/Pricing" ? "active" : "",
    },
    {
      id: 5,
      name: "Contact Us",
      path: "/Contact",
      Active: pathname === "/Contact" ? "active" : "",
    },
  ];

  const { user, logout } = useAuth();
  const [loading, setLoading] = useState(false);

  // Shared with every other screen. The header never remounts, so when it held
  // its own copy it went on offering a free trial that had already started.
  const { subscription, refreshSubscription, loaded } = useSubscription();
  const subscriptionState = subscription.state;

  // if (user && user.token !== "token") {
  //   routes.push({
  //     id: 4,
  //     name: "Pricing",
  //     path: "/Pricing",
  //     Active: pathname === '/Pricing' ? "active" : ""
  //   });
  // }

  const handleFreeTrialClick = async () => {
    setHandleNav(true);
    if (!user) {
      // Swal.fire({
      //   icon: 'error',
      //   title: 'Please Login First',
      //   text: 'You need to be logged in to access the free trial.',
      // });
      navigate("/Signup?activeTab=signUp");
      return;
    }

    try {
      setLoading(true);
      const { data } = await axios.get(`${API_URL}/payment/success-free-user`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      });

      if (data?.statusCode == 200 || data?.statusCode == 201) {
        const stored = JSON.parse(localStorage.getItem("user") ?? "{}");
        if (stored) {
          stored.paid = "paid";
          localStorage.setItem("user", JSON.stringify(stored));
        }

        // Refresh the shared state so this link disappears and every other
        // screen sees the trial immediately, then go where it is used. No
        // dialog: the header swaps the link for the days remaining and the
        // projects page offers New Project.
        await refreshSubscription();
        setLoading(false);
        navigate("/Project");
      } else if (data?.statusCode == 400) {
        // Re-read the state too: "already used" means the app's picture of this
        // account was out of date, and leaving it that way is what produced a
        // Free Trial link that refused to do anything.
        await refreshSubscription();
        setLoading(false);

        Swal.fire({
          icon: "info",
          title: "Could not start the trial",
          text: data?.message ?? "Please try again.",
        });
      } else {
        setLoading(false);
        navigate("/PaymentFailed");
      }
    } catch (error) {
      if (error?.response?.status == 401) {
        handleSessionExpiry();
      } else {
        Swal.fire(error?.message);
      }
      setLoading(false);
    }
  };

  // Get the token from local storage

  const [handleNav, setHandleNav] = useState(true);
  const handleNavBar = () => {
    setHandleNav(true);
  };

  const handleNavBarStatus = () => {
    setHandleNav(false);
  };

  const handlePage = () => {
    setHandleNav(true);
  };

  const capitalizeName = (name) => {
    if (name) {
      const names = name.split(" ");
      const capitalizedNames = names.map(
        (n) => n.charAt(0).toUpperCase() + n.slice(1)
      );
      return capitalizedNames.join(" ");
    }
    return "";
  };

  const handleCancel = () => {
    Swal.fire({
      title: "Are you sure you want to cancel your subscription?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        // If the user clicks 'Yes'
        // Perform the subscription cancellation logic here
        // For example, call your API to cancel the subscription

        // Show the second popup confirming the cancellation
        Swal.fire({
          title: "Your Subscription has been canceled",
          icon: "success",
          confirmButtonText: "OK",
        });
      }
    });
  };

  return (
    <div>
      <header className="container-fluid header_section ds-instrument">
        <nav className="navbar navbar-expand-lg navbar-light p-0">
          <div className="container">
            <Link className="navbar-brand logo_area p-0" to="/">
              <img src={logo} alt="Duct Sizer Pro" />
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarScroll"
              aria-controls="navbarScroll"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={handleNavBarStatus}
            >
              <i className=" fa-solid fa-bars"></i>
            </button>
            <div
              className={`collapse navbar-collapse ${handleNav ? "" : "show"}`}
              id="navbarScroll"
            >
              <ul className="navbar-nav me-auto  my-lg-0 navbar-nav-scroll">
                {/* Projects had no entry in the navigation at all. The only
                    route to them was the home page's call to action, and the
                    account menu offered nothing but Logout - so after starting
                    a trial there was no visible way to reach or create one. */}
                {user && (
                  <li className="nav-item">
                    <Link
                      className={`nav-link ${
                        pathname === "/Project" ? "active" : ""
                      }`}
                      to="/Project"
                      onClick={handleNavBar}
                    >
                      My Projects
                    </Link>
                  </li>
                )}
                {routes.map(({ id, name, path, Active }) =>
                  user &&
                  path === "/FreeCalculator" &&
                  user.paid == "paid" ? null : (
                    <li className="nav-item" key={id}>
                      <Link
                        className={`nav-link ${Active}`}
                        to={path}
                        id={id}
                        onClick={handleNavBar}
                      >
                        {name}
                      </Link>
                    </li>
                  )
                )}
              </ul>

              <div className="d-flex align-items-center nav_right_side">
                {/* Days left, while a trial or subscription is running. There
                    was no way to see this anywhere in the app. */}
                {user && subscriptionState === ACTIVE && (
                  <span className="ds-chip me-3">
                    {subscription.daysRemaining === 1
                      ? "Last day"
                      : `${subscription.daysRemaining} days left`}
                  </span>
                )}

                {/* Offered only to accounts that have never subscribed, and
                    only once the real state is known - rendering it while the
                    status is still loading made it flash for subscribers. The
                    condition used to read user.paid from the cached copy in
                    localStorage, which does not update when a trial starts, so
                    "Free Trial" kept inviting people to start one they were
                    already using. */}
                {(!user || (loaded && subscriptionState === NONE)) && (
                  <ul
                    className="navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll"
                    // style={"--bs-scroll-height: 100px;"}
                  >
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        style={{ cursor: "pointer" }}
                        onClick={handleFreeTrialClick}
                      >
                        Free Trial
                      </a>
                    </li>
                  </ul>
                )}
                {user ? (
                  <div className="d-flex align-items-center">
                    {/* <span className="me-2 text-white">{user?.name}</span> */}

                    <div className="dropdown">
                      <button
                        className="btn btn_signin dropdown-toggle m-0 p-0"
                        type="button"
                        id="dropdownMenuButton"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        {" "}
                        <i className="fa fa-user" aria-hidden="true"></i>
                        {" " + capitalizeName(user?.name) + " "}
                      </button>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                      >
                        {/* Project List is always here for a signed-in user.
                            It used to be gated on the cached paid/userSubs
                            flags, so an account whose state had changed - or
                            whose cache was simply stale - saw a menu containing
                            nothing but Logout, with no route to its own work. */}
                        <li>
                          <Link className="dropdown-item" to="/Project">
                            <i className="fa fa-list" aria-hidden="true"></i>{" "}
                            Project List
                          </Link>
                        </li>
                        <li>
                          <Link className="dropdown-item" to="/Pricing">
                            <i className="fa fa-tags" aria-hidden="true"></i>{" "}
                            {subscriptionState === ACTIVE
                              ? "Subscription"
                              : "Plans & free trial"}
                          </Link>
                        </li>
                        {subscriptionState === ACTIVE && (
                          <li>
                            <button
                              className="dropdown-item"
                              onClick={handleCancel}
                            >
                              <i
                                className="fa fa-window-close"
                                aria-hidden="true"
                              ></i>{" "}
                              Cancel Subscription
                            </button>
                          </li>
                        )}
                        <li>
                          <button onClick={logout} className="dropdown-item">
                            <i
                              className="fa fa-sign-out"
                              aria-hidden="true"
                            ></i>{" "}
                            Logout
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                ) : (
                  <Link
                    to="Signup"
                    className="btn btn_signin"
                    onClick={handlePage}
                  >
                    SIGN IN
                  </Link>
                )}
              </div>
            </div>
          </div>
        </nav>
      </header>
    </div>
  );
};

export default Header;
